import SubscribersPage from './subscribers-page';

export default SubscribersPage;